/**
 * The following scripts get applied to both the front end and editor.
 *
 */

// https://codepen.io/stoumann/pen/ExydEYL
function setDetailsHeight(selector, wrapper = document) {
    const setHeight = (detail, open = false) => {
        detail.open = open;
        const rect = detail.getBoundingClientRect();
        detail.dataset.width = rect.width;
        detail.style.setProperty(open ? `--expanded` : `--collapsed`,`${rect.height}px`);
    }

    const details = wrapper.querySelectorAll(selector);
    const RO = new ResizeObserver(entries => {
        return entries.forEach(entry => {
            const detail = entry.target;
            if(detail.open != true) {
                const width = Math.round(detail.dataset.width);
                if (width !== Math.round(entry.contentRect.width)) {
                    detail.removeAttribute('style');
                    setHeight(detail);
                    setHeight(detail, true);
                    detail.open = false;
                }
            } else {
                let summaryHeight = detail.querySelector('summary').offsetHeight;
                let contentHeight = detail.querySelector('.toggle-content').offsetHeight;
                detail.dataset.width = detail.offsetWidth;
                detail.style.setProperty(`--collapsed`,`${summaryHeight}px`);
                detail.style.setProperty(`--expanded`,`${contentHeight + summaryHeight}px`);
            }
        })
    });
    details.forEach(detail => {
        RO.observe(detail);
    });
}



document.addEventListener('DOMContentLoaded', function() {
    setDetailsHeight('details.toggle');
    
    
    /** Close others <details> tag */
    const allDetails = document.querySelectorAll("details.toggle")
    allDetails.forEach((details) => {
        details.addEventListener("toggle", (e) => {
            if (details.open) {
                allDetails.forEach((details) => {
                    if (details != e.target && details.open) {
                        details.open = false
                    }
                })
            }
        })
    })
});

